// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__10JGy","empty":"ModalGraph_empty__1fUPI"};